import { Box } from "@mui/material";
import { QRCodeSVG } from "qrcode.react";
import { forwardRef } from "react";
import { qrStyles } from "styles/common/qr.styles";

interface QRCodeContainerProps {
  link: string;
}

const QRCodeContainer = forwardRef<HTMLDivElement, QRCodeContainerProps>(
  ({ link }, ref) => {
    return (
      <Box sx={qrStyles.qrContainer} ref={ref}>
        <Box sx={qrStyles.qrBox}>
          <QRCodeSVG value={link} size={180} />
        </Box>
      </Box>
    );
  }
);

QRCodeContainer.displayName = "QRCodeContainer";

export default QRCodeContainer;
